import {BaseForm} from 'craftable';
import {getValidationFieldClasses} from '../../utils.js'

function documentWysiwygInsert(insertText){
    var $wysiwyg = $('#wysiwyg');
    $wysiwyg.trumbowyg('execCmd', {cmd: 'insertHTML', param: '<span class="wysiwyg-custom-insert">'+insertText+"</span>&nbsp;"});
}

export default {
	mixins: [BaseForm],
    props: {
        'trans': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        'attendancePropsButtons': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        'restaurantDynamicFieldsNames': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
    },
    data: function() {

        var adtButtons = {};
        var adtButtonsList = {
            "employees": [],
            "contracts": [],
        };
        var groups = [];

        for(var group in this.attendancePropsButtons)
        {
            var selButtons = [];
            var groupButtons = this.attendancePropsButtons[group];
            for(var x in groupButtons)
            {
                var nameRaw = x.replace("[[","").replace("]]","").replace("custom_","");
                selButtons.push("insert_"+groupButtons[x]);
                adtButtons["insert_"+groupButtons[x]] =
                    {
                        fn: function(a) {
                            documentWysiwygInsert(a);
                        },
                        tag: 'xy',
                        title: (group == "custom" ? this.restaurantDynamicFieldsNames[nameRaw] : this.trans[groupButtons[x]]),
                        text: (group == "custom" ? this.restaurantDynamicFieldsNames[nameRaw] : this.trans[groupButtons[x]]),
                        isSupported: function () { return true; },
                        param: '[['+groupButtons[x]+']]' ,
                        forceCSS: false,
                        hasIcon: false
                    };
            }

            adtButtons[group] = {
                dropdown: selButtons,
                title: this.trans[group],
                hasIcon: false
            };
            groups.push(group);
        }

        return {
             documentWysiwygConfig: {
                removeformatPasted: true,
                semantic: false,
                resetCss: true,
                btns: [
                    ['formatting'],
                    ['strong', 'em', 'underline',  'del', 'superscript', 'subscript'],
                    ['align'],
                    ['unorderedList', 'orderedList', 'table'],
                    ['foreColor', 'backColor'], ['insertImage'],
                    ['link', 'image'], ['horizontalRule'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['removeformat'],
                    ['fullscreen', 'viewHTML'],
                    groups

                ],
                btnsDef: adtButtons
            },

        }
    },

    methods: {

        //fixed default Craftable onFail method
        onFail: function onFail(errors) {
            this.submiting = false;
            var bag = this.$validator.errors;
            bag.clear();
            Object.keys(errors).map(function (key) {
                var splitted = key.split('.', 2);
                // we assume that first dot divides column and locale (TODO maybe refactor this and make it more general)
                if (splitted.length > 1) {
                    bag.add({ field: splitted[0] + '_' + splitted[1], msg: errors[key][0]});
                } else {
                    bag.add({ field: key, msg: errors[key][0]});
                }
            });
        },

        getValidationFieldClasses,
    }
};



// WEBPACK FOOTER //
// ./resources/assets/admin/js/app-components/Form/AppForm.js